import { useTranslation } from "react-i18next"
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card"
import { GymBrandingForm } from "@/components/profile/gym-branding-form"
import { PageHeader } from "@/components/shared/page-header"

export default function GymSettingsPage() {
  const { t } = useTranslation()

  return (
    <div className="space-y-6">
      <PageHeader title={t("gymSettings.title", "Gym Settings")} />

      <Card>
        <CardHeader>
          <CardTitle>{t("gymSettings.branding", "Branding")}</CardTitle>
          <CardDescription>
            {t(
              "gymSettings.brandingDescription",
              "Manage your gym's branding — logo, name and primary color shown across the app and login page."
            )}
          </CardDescription>
        </CardHeader>
        <CardContent>
          <GymBrandingForm />
        </CardContent>
      </Card>
    </div>
  )
}
